export const clientStatusOptions = [
	{ value: "active", label: "Active" },
	{ value: "inactive", label: "Inactive" },
];

export const clientStatusLookup = { active: 0, inactive: 1 };
